export default __webpack_public_path__ + "static/media/image1.80cff0f6.webp";